import getIn from 'lodash/get';
import noop from 'lodash/noop';

import * as Utils from '../../../utils';

// eslint-disable-next-line require-yield
export function* trackStartedfromSource({ payload: { type: trackType } }) {
  getIn(
    window,
    'DesktopBridge.sourceTypeChange',
    noop,
  )(Utils.SourceType.getDesktopBridgeSourceType(trackType));
}
